var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSanadPlusInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.327 24.429h15.407l.108-.001a5.525 5.525 0 0 1 11.046-.086l2.553-.02c.822-3.836.695-5.216-.637-6.269-.99-4.527-2.547-6.595-7.226-9.35H28.41l-5.631 5.632h-6.163c-2.019 0-5.07 1.593-6.269 3.506h2.55c.067.674-.179 1.019-.956 1.594h-1.806v2.337c-.739-.087-.933.141-.957.957.397.968.786 1.323 1.7 1.7h3.401a5.525 5.525 0 0 1 11.049 0zm10.839-10.307H25.54l3.613-3.825h7.013v3.825zm2.762 0v-3.825h6.163c2.504 1.307 3.088 2.166 3.294 3.825h-9.457z",
    fill: "#818B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.34 24.535a4.463 4.463 0 1 1 8.925 0 4.463 4.463 0 0 1-8.925 0zm4.463 2.762a2.763 2.763 0 1 1 0-5.525 2.763 2.763 0 0 1 0 5.525zM46.366 20.072a4.463 4.463 0 1 0 0 8.925 4.463 4.463 0 0 0 0-8.925zm-2.763 4.463a2.763 2.763 0 1 0 5.525 0 2.763 2.763 0 0 0-5.525 0z",
    fill: "#818B9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m55.536 34.278-13.032 13.02a1.514 1.514 0 0 1-1.07.444H19.142c-.26 0-.515.067-.742.194l-3.51 1.973c-.103.058-.2.128-.286.208l-6.638 6.14v-9.39c0-.402.16-.788.444-1.072l12.023-12.012a1.514 1.514 0 0 1 1.07-.443h17.632c.351 0 .693.12.944.367.55.543 1.46 1.593 1.355 2.513-.088.764-.89 1.546-1.378 1.958a1.32 1.32 0 0 1-.857.296H26.391a.626.626 0 0 0 0 1.253h15.081c.379 0 .743-.142 1.023-.397l9.516-8.706c.29-.266.675-.414 1.068-.383 2.032.164 2.79.872 2.885 2.98.018.396-.147.777-.428 1.057z",
    fill: "#818B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSanadPlusInsurance);
export default __webpack_public_path__ + "static/media/sanad-plus-insurance.632aa3f46792e98ab7ea9bc0656fa920.svg";
export { ForwardRef as ReactComponent };